import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import * as styles from "./Navigation-tw-styles"
import MainNavAccordion from "./MainNavAccordion"
import TopNavAccordion from "./TopNavAccordion"
import { getStockDetails } from "../../../../../service/StockService"

const Navigation = ({
  navigation,
  topNavigation,
  isMobileNavOpen,
  toggleMobileNav,
  variant,
}) => {
  const style = styles[variant] || styles.defaultStyle
  const [stockDetails, setStockDetails] = useState([])
  const { navToggle } = style

  useEffect(() => {
    async function fetchData() {
      let data = await getStockDetails()
      setStockDetails(data)
    }
    fetchData()
  }, [])

  const renderNavigationItems = () => (
    <>
      <div className={`mobilenavParent ${isMobileNavOpen ? "close" : "open"}`}>
        <MainNavAccordion collection={navigation} />
        <TopNavAccordion collection={topNavigation} />
        <div className={style?.mobileStockPrice}>
          {stockDetails?.length > 0 && (
            <p>
              {stockDetails[0]?.exchange}: {stockDetails[0]?.symbol} $
              {stockDetails[0]?.lastTrade} USD{" "}
              {stockDetails[0]?.changeNumber == 0
                ? stockDetails[0]?.changeNumber
                : stockDetails[0]?.changeNumber.toFixed(2)}{" "}
              (
              {stockDetails[0]?.changePercent == 0
                ? stockDetails[0]?.changePercent
                : stockDetails[0]?.changePercent.toFixed(2)}
              %)
            </p>
          )}
        </div>
      </div>
    </>
  )
  return (
    <>
      <div className={navToggle}>
        <span
          className={
            isMobileNavOpen ? "openMenu fas fa-times" : "closemenu fas fa-bars"
          }
          onClick={toggleMobileNav}
        ></span>
      </div>
      <div className={style?.navContainer}>{renderNavigationItems()}</div>
    </>
  )
}

Navigation.propTypes = {
  navigation: PropTypes.array,
  topNavigation: PropTypes.array,
  isMobileNavOpen: PropTypes.bool,
  toggleMobileNav: PropTypes.func,
  variant: PropTypes.string,
}

export default Navigation
